package pages.outbound

import csstype.array
import ics.materialUI.components.classes.ContentFieldMapping

object OutboundDetailPageFieldMappings {
    object Order {
        val customerInformationCardHeaders = arrayOf(
            "owner",
            "customer",
            "customerReference",
            "name",
            "address",
            "zipCode",
            "city",
            "country",
            "email",
            "customerReference",
            "phone"
        )

        val orderInformationCardHeaders = arrayOf(
            "articleCategory",
            "manuallyChecked",
            "endDateTime",
            "orderDate",
            "parcelShopId",
            "priority",
            "reference",
            "batch"
        )

        val statusInformationCard = arrayOf(
            "pickedAmount",
            "requestedDateTime",
            "inputDate",
            "onHold",
            "outboundTime",
            "statusDescription",
            "amountToPick",
            "temporaryLocation",
            "packingStatus"
        )

        val deliverInformationCardHeaders = arrayOf(
            "deliveryUnitsAmount",
            "boxType",
            "shippingAgent",
            "packer",
            "packingStation",
            "outboundTransportUnit",
            "packingSlipEmailExtra",
            "mailPackingSlip",
            "specialPackingSlip",
            "trackAndTrace",
            "deliveryCode",
            "deliveryUnits",
            "deliveryOption",
            "deliveryProposal",
        )

        val extraInformationCardHeaders = arrayOf(
            "message",
            "service",
            "special",
            "explanation",
            "webShop"
        )

        val fieldMapping: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "recordId",
                "Record Id",
            ),
            ContentFieldMapping(
                "owner",
                "Owner",
            ),
            ContentFieldMapping(
                "deliveryUnitsAmount",
                "Delivery units",
            ),
            ContentFieldMapping(
                "address",
                "Address",
            ),
            ContentFieldMapping(
                "articleCategory",
                "Article category",
            ),
            ContentFieldMapping(
                "message",
                "Message",
            ),
            ContentFieldMapping(
                "manuallyChecked",
                "Manually checked",
            ),
            ContentFieldMapping(
                "boxType",
                "Box type",
            ),
            ContentFieldMapping(
                "endDateTime",
                "End date",
            ),
            ContentFieldMapping(
                "email",
                "Email",
            ),
            ContentFieldMapping(
                "shippingAgent",
                "Shipping agent",
            ),
            ContentFieldMapping(
                "Picked amount",
                "Picked amount"
            ),
            ContentFieldMapping(
                "requestedDateTime",
                "Requested date",
            ),
            ContentFieldMapping(
                "packer",
                "Packer",
            ),
            ContentFieldMapping(
                "packingStation",
                "Packing station",
            ),
            ContentFieldMapping(
                "inputDate",
                "Input date",
            ),
            ContentFieldMapping(
                "customer",
                "Customer",
            ),
            ContentFieldMapping(
                "customerReference",
                "Customer reference",
            ),
            ContentFieldMapping(
                "country",
                "Country",
            ),
            ContentFieldMapping(
                "name",
                "Name",
            ),
            ContentFieldMapping(
                "onHold",
                "On hold",
            ),
            ContentFieldMapping(
                "orderDate",
                "Order date",
            ),
            ContentFieldMapping(
                "outboundTransportUnit",
                "Outbound Transport Unit",
            ),
            ContentFieldMapping(
                "outboundTime",
                "Outbound time",
            ),
            ContentFieldMapping(
                "parcelShopId",
                "Parcel shop Id",
            ),
            ContentFieldMapping(
                "packingSlipEmailExtra",
                "Extra packing slip email",
            ),
            ContentFieldMapping(
                "mailPackingSlip",
                "Mail packing slip",
            ),
            ContentFieldMapping(
                "city",
                "City",
            ),
            ContentFieldMapping(
                "zipCode",
                "Zipcode",
            ),
            ContentFieldMapping(
                "priority",
                "Priority",
            ),
            ContentFieldMapping(
                "reference",
                "Reference",
            ),
            ContentFieldMapping(
                "regionalCode",
                "Regional code",
            ),
            ContentFieldMapping(
                "service",
                "Service",
            ),
            ContentFieldMapping(
                "special",
                "Special",
            ),
            ContentFieldMapping(
                "specialPackingSlip",
                "Special packing slip",
            ),
            ContentFieldMapping(
                "statusDescription",
                "Status",
            ),
            ContentFieldMapping(
                "amountToPick",
                "Amount to Pick",
            ),
            ContentFieldMapping(
                "phone",
                "Phone",
            ),
            ContentFieldMapping(
                "temporaryLocation",
                "Temporary location",
            ),
            ContentFieldMapping(
                "explanation",
                "Explanation",
            ),
            ContentFieldMapping(
                "trackAndTrace",
                "Track & Trace",
            ),
            ContentFieldMapping(
                "deliveryCode",
                "Delivery code",
            ),
            ContentFieldMapping(
                "packingStatus",
                "Packing status",
            ),
            ContentFieldMapping(
                "batch",
                "Batch",
            ),
            ContentFieldMapping(
                "deliveryUnits",
                "Delivery units",
            ),
            ContentFieldMapping(
                "deliveryOption",
                "Delivery option",
            ),
            ContentFieldMapping(
                "deliveryProposal",
                "Delivery Proposal",
            ),
            ContentFieldMapping(
                "webShop",
                "Webshop",
            )
        )
    }

    object OrderLines {
        val headerSequence: Array<String> = arrayOf(
            "recordId",
            "externalRecordId",
            "warehouseCode",
            "article",
            "articleNumber",
            "articleCategory",
            "colorDescription",
            "sizeCode",
            "lengthSize",
            "description",
            "variantCode",
            "suggestedRetailPrice",
            "statusDescription",
            "orderAmount",
            "amountToPick",
            "pickedAmount",
            "packedAmount",
            "message"
        )

        val fieldMapping: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "suggestedRetailPrice",
                "Suggested retail price"
            ),
            ContentFieldMapping(
                "article",
                "Article"
            ),
            ContentFieldMapping(
                "articleCategory",
                "Article category"
            ),
            ContentFieldMapping(
                "articleNumber",
                "Article Id"
            ),
            ContentFieldMapping(
                "message",
                "Message"
            ),
            ContentFieldMapping(
                "pickedAmount",
                "Picked Amount"
            ),
            ContentFieldMapping(
                "packedAmount",
                "Packed amount"
            ),ContentFieldMapping(
                "colorDescription",
                "Color description"
            ),
            ContentFieldMapping(
                "lengthSize",
                "Size"
            ),
            ContentFieldMapping(
                "sizeCode",
                "Size code"
            ),
            ContentFieldMapping(
                "warehouseCode",
                "Warehouse code"
            ),
            ContentFieldMapping(
                "description",
                "Description"
            ),
            ContentFieldMapping(
                "orderAmount",
                "Ordered amount"
            ),
            ContentFieldMapping(
                "outboundOrder",
                "outboundOrder"
            ),
            ContentFieldMapping(
                "externalRecordId",
                "External orderline Id"
            ),
            ContentFieldMapping(
                "statusDescription",
                "Status"
            ),
            ContentFieldMapping(
                "amountToPick",
                "Amount to pick"
            ),
            ContentFieldMapping(
                "variantCode",
                "Variant code"
            )
        )
    }
}